import React, { useId, useMemo } from 'react';

const defaultInputStyle = {
  width: '100%',
  padding: '8px 10px',
  fontSize: 14,
  border: '1px solid #ccc',
  borderRadius: 6,
  boxSizing: 'border-box',
};

/**
 * 單行輸入＋ datalist 建議（點擊／輸入即可篩選歷史選項，與先前後台一致）
 */
export default function SuggestMultilineField({
  label,
  value,
  onChange,
  suggestions = [],
  placeholder = '',
  inputStyle,
  style,
  id,
}) {
  const autoId = useId();
  const fieldId = id || autoId;
  const listId = `${fieldId}-datalist`;
  const mergedInput = { ...defaultInputStyle, ...(inputStyle || {}) };
  const list = useMemo(
    () => (Array.isArray(suggestions) ? suggestions.map((s) => String(s).trim()).filter(Boolean) : []),
    [suggestions],
  );

  return (
    <div style={{ marginBottom: 12, ...(style || {}) }}>
      {label ? (
        <label htmlFor={fieldId} style={{ display: 'block', marginBottom: 4, fontSize: 14 }}>
          {label}
        </label>
      ) : null}
      <input
        id={fieldId}
        type="text"
        list={listId}
        value={value || ''}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        style={mergedInput}
        autoComplete="off"
      />
      <datalist id={listId}>
        {list.map((s) => (
          <option key={s} value={s} />
        ))}
      </datalist>
    </div>
  );
}
